import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import {
  COMPANY_SETTING_FRAGMENT,
  CompanySettingFragment,
} from "graphql/fragment/company.setting.fragment";
import { ID } from "../../../utils/id";

interface Data {
  setting: CompanySettingFragment;
}
interface Variables {
  id: ID;
  input: {
    value?: string;
  };
}
const MUTATION = gql`
  mutation update($input: CompanySettingInput!, $id: ID!) {
    setting: updateCompanySetting(setting: $input, id: $id) {
      ...CompanySetting
    }
  }
  ${COMPANY_SETTING_FRAGMENT}
`;

export const useUpdateCompanySettingMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "getSettings",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};
